import {
	HTTP_REQUEST,
	HTTP_CLEAR,
} from "./actions";

const actionReducer = {
	[HTTP_REQUEST]: ({ ...state }, { index, data, response, success }) => {
		state[index] = {
			pending: success === null,
			success: success === undefined ? null : success,
			response: response && {
				ok: response.ok,
				json: () => data,
			}
		};
		return state;
	},
	[HTTP_CLEAR]: ({ ...state }, { index }) => {
		delete state[index];
		return state;
	}
};

export default function(state={}, action) {
	const reducer = actionReducer[action.type];
	if (!reducer) {
		return state;
	}
	return reducer(state, action);
}
